import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Badge } from '../../ui/badge';
import { Table2, Clock, Receipt, Plus, ChefHat, X } from 'lucide-react';

const TableCard = ({ mesa, onClick, onCancelClick, formatDuration }) => {
  return (
    <Card 
      onClick={() => onClick(mesa)}
      className={`cursor-pointer transition-all hover:shadow-lg relative overflow-hidden ${
        mesa.status === 'ocupada' ? 'border-green-300 bg-green-50/30' : 'bg-white hover:bg-blue-50/30 hover:border-blue-200'
      } ${mesa.has_kitchen_ready ? 'kitchen-alert-glow' : ''}`}
      data-testid={`table-card-${mesa.numero}`}
    >
      {mesa.has_kitchen_ready && (
        <div className="absolute top-0 left-0 right-0 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs font-bold py-1 px-2 flex items-center justify-center gap-1 animate-pulse">
          <ChefHat size={12} />
          COCINA LISTA!
        </div>
      )}
      
      {mesa.status === 'ocupada' && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCancelClick(mesa);
          }}
          className="absolute top-2 right-2 w-6 h-6 rounded-full bg-red-100 hover:bg-red-200 flex items-center justify-center text-red-600 hover:text-red-700 transition-colors z-10"
          title="Cancelar mesa"
          data-testid={`cancel-table-${mesa.numero}`}
        >
          <X size={14} />
        </button>
      )}
      
      <CardHeader className={`pb-2 ${mesa.has_kitchen_ready ? 'pt-8' : ''}`}>
        <div className="flex items-center justify-between">
          <CardTitle className="text-3xl font-bold">{mesa.numero}</CardTitle>
          {mesa.status === 'ocupada' ? (
            <Badge className="bg-green-500 text-white text-xs">Ocupada</Badge>
          ) : (
            <Badge variant="outline" className="text-blue-500 border-blue-300 text-xs">
              <Plus size={12} className="mr-1" />
              Libre
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        {mesa.status === 'ocupada' && mesa.session ? (
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm text-gray-600">
              <span className="flex items-center gap-1"><Clock size={14} />{formatDuration(mesa.session.duration_minutes)}</span>
              <span className="flex items-center gap-1"><Receipt size={14} />{mesa.session.order_count}</span>
            </div>
            <div className="text-center py-2 bg-white rounded-lg border">
              <span className="text-2xl font-bold text-green-600">{mesa.session.total.toFixed(2)}€</span>
            </div>
            {mesa.total_kitchen_items > 0 && (
              <div className={`text-xs text-center py-1 rounded ${mesa.has_kitchen_ready ? 'bg-orange-100 text-orange-700 font-medium' : 'bg-gray-100 text-gray-500'}`}>
                <ChefHat size={12} className="inline mr-1" />
                {mesa.kitchen_ready_count}/{mesa.total_kitchen_items} cocina
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-4 text-blue-400">
            <Plus size={32} className="mx-auto mb-1" />
            <p className="text-xs font-medium">Toca para pedir</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TableCard;
